import { render, staticRenderFns } from "./LicenseExpiryManagement.vue?vue&type=template&id=2feccd20"
import script from "./LicenseExpiryManagement.vue?vue&type=script&lang=js"
export * from "./LicenseExpiryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports